import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { OpportunityService } from '@http/clients/opportunity.service';
import { AwaiterService } from '@services/awaiter.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { IconSanitizerService } from 'ngx-lib';

@Component({
    selector: 'app-custom-cell-favorite',
    templateUrl: './custom-cell-favorite.component.html',
    styleUrls: ['./custom-cell-favorite.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class CustomCellFavoriteComponent implements ICellRendererAngularComp {
    isFavorite: boolean;

    starIcon: SafeHtml;

    params!: any;

    constructor(
        private readonly iconSanitizer: IconSanitizerService,
        private readonly opportunityService: OpportunityService,
        private readonly awaiter: AwaiterService
    ) {
        this.starIcon = this.isFavorite = false;
    }

    agInit(params: ICellRendererParams<any, any, any>): void {
        this.params = params;
        this.isFavorite = params.value;
        this.starIcon = this.iconSanitizer.getIcon('star');
    }

    refresh(): boolean {
        return false;
    }

    toggleFav(event: Event) {
        this.onFavoriteChanged();
        event.preventDefault();
        event.stopPropagation();
    }

    onKeyDownToggleFav(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.toggleFav(event);
        }
    }

    async onFavoriteChanged() {
        await this.awaiter.awaitAction('Setting Favorite', async () => {
            try {
                if (!this.isFavorite) {
                    await this.opportunityService.setAsFavorite(this.params.data.id);
                    this.isFavorite = true;
                } else {
                    await this.opportunityService.removeFromFavorite(this.params.data.id);
                    this.isFavorite = false;
                }
            } catch {
                throw new Error('Error changing favorite mode');
            }
        });
    }
}
